import { type CaseReducer } from '@reduxjs/toolkit';

import { emptyCredential } from '../initialStates';
import { type SessionState } from '../types';

const loginPendingCase: CaseReducer<SessionState> = state => {
  state.credentials = emptyCredential;
  state.status = 'unknown';
  state.isLoading = true;
  state.hasError = false;
};

export { loginPendingCase };
